import { useTranslation } from 'react-i18next';

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function ConfirmationModal({ open, onConfirm, onClose }: {
    open: boolean; onConfirm: () => void; onClose: () => void
}) {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                {t("mdm.are_you_sure")}
            </DialogTitle>

            <DialogContent dividers>
                {t("mdm.irreversible_action")}
            </DialogContent>

            <DialogActions>
                <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={onClose}
                    startIcon={<CancelIcon fontSize="small" />}
                    sx={{
                        textTransform: 'none',
                        fontSize: '0.75rem',
                        padding: '6px 10px',
                        minHeight: '30px'
                    }}
                >
                    {t("mdm.cancel")}
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={onConfirm}
                    startIcon={<CheckCircleIcon fontSize="small" />}
                    sx={{
                        textTransform: 'none',
                        fontSize: '0.75rem',
                        padding: '6px 10px',
                        minHeight: '30px',
                    }}
                >
                    {t("mdm.confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmationModal;